export default {
  isBotNameValid: (name) => {
    let data = { valid: true, error: "" }
    if (name.length < 4) {
      data.valid = false
      data.error = "Bot Name should be longer than 4 symbols"
    } else if (name.length > 64) {
      data.valid = false
      data.error = "Bot Name should be less than 64 symbols"
    } else if (name.match(/[`!@#$%^&*()_+\-=\[\]{};\':"\\|,.<>\/?~]/)) {
      data.valid = false
      data.error = "Bot Name contains special character"
    }
    return data
  },
  isBotDataValid: (botData) => (Array.isArray(botData) && botData.length) 
}